// extracted by mini-css-extract-plugin
export default {"pendingTran":"CryptoDepositHistoryList_pendingTran__qFTB3","depositCategoryTitle":"CryptoDepositHistoryList_depositCategoryTitle__VBtDd"};